import { Box } from '@chakra-ui/react';

import { tableHeadLists } from './const';
import TableListProduct from '@pages/UploadMappingV2/components/Table/TableListProduct';
import useGetProductBundle from '@pages/UploadMappingV2/hooks/query/useGetListProduct';

export default function ProductBundle() {
    const { data, isLoading } = useGetProductBundle({ type: 'bundle', page: 1, limit: 3, search: null });
    const tableData = data?.data?.page_data;

    return (
        <Box>
            <TableListProduct
                isCanAddItem={false}
                tableHeadLists={tableHeadLists}
                tableData={tableData}
                data={data?.data}
                isLoading={isLoading}
            />
        </Box>
    );
}
